import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
}

export const Button = styled.button<IProps>`
  ${mixin.flex({ display: 'inline-flex' })}

  &[disabled],
  &.disabled {
    background: #dddddd !important;
    pointer-events: none;
  }

  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;

  svg + span {
    margin-left: 4px;
  }

  // ios
  @supports (-webkit-touch-callout: none) {
    margin: 0;
  }

  @media ${({ theme }) => theme.media.smMax} {
    svg + span {
      margin-left: ${mixin.pxToVw('4')};
    }
  }
`;
